module.exports = __webpack_public_path__ + "media/images/85/narcolepsy_moon_mountains-981a1e63fbbdd67f393f15e2a0d1ae0c.jpg";